import { Button, Dialog, DialogContent, IconButton, Stack } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import HighlightOffOutlinedIcon from '../Svgs/HighlightOffOutlinedIcon'
import { defaultFunction } from '../../utilities/utilities'
import './InfraredScanErrorDialog.sass'

function InfraredScanErrorDialog({
  open = false,
  onClose = defaultFunction,
}) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="infrared-scan-error-dialog"
    >
      <DialogContent>
        <Stack className="infrared-scan-error-dialog-content" alignItems="center">
          <Stack className="infrared-scan-error-dialog-body" alignItems="center">
            <IconButton
              aria-label="close"
              onClick={onClose}
              className="infrared-scan-error-dialog-close"
            >
              <CloseIcon />
            </IconButton>
            <Stack className="infrared-scan-error-dialog-heading" alignItems="center" gap={2}>
              <HighlightOffOutlinedIcon
                className="infrared-scan-error-dialog-icon"
                width={56}
                height={56}
                fill="#D0021B"
              />
              <h2>{t('Could not read document')}</h2>
            </Stack>
            <p>{t('Could not read document description')}</p>
          </Stack>
          <Button
            fullWidth
            variant="contained"
            onClick={onClose}
          >
            {t('Retry capture credential')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default InfraredScanErrorDialog
